import { create } from 'zustand'
import authService from '../services/authService'

export const useAuthStore = create((set, get) => ({
  user: authService.getStoredUser(),
  isAuthenticated: authService.isAuthenticated(),
  isLoading: false,
  error: null,

  login: async (credentials) => {
    set({ isLoading: true, error: null })
    try {
      const response = await authService.login(credentials)
      if (response.status === 'success') {
        const { access_token, refresh_token, user } = response.data
        authService.setTokens(access_token, refresh_token)
        authService.setUser(user)
        set({ user, isAuthenticated: true, isLoading: false, error: null })
        return { success: true }
      }
      throw new Error(response.message || 'Đăng nhập thất bại')
    } catch (error) {
      const message = error.response?.data?.message || error.message || 'Đăng nhập thất bại'
      set({ isLoading: false, error: message })
      return { success: false, error: message }
    }
  },

  exchangeSso: async () => {
    set({ isLoading: true, error: null })
    try {
      const response = await authService.exchangeSso()
      if (response.status === 'success') {
        const { access_token, refresh_token, user, redirect } = response.data
        authService.setTokens(access_token, refresh_token)
        authService.setUser(user)
        set({ user, isAuthenticated: true, isLoading: false, error: null })
        return { success: true, redirect }
      }
      throw new Error(response.message || 'Đăng nhập SSO thất bại')
    } catch (error) {
      const message = error.response?.data?.message || error.message || 'Đăng nhập SSO thất bại'
      set({ isLoading: false, error: message })
      return { success: false, error: message }
    }
  },

  logout: async () => {
    set({ isLoading: true })
    await authService.logout()
    set({ user: null, isAuthenticated: false, isLoading: false, error: null })
  },

  // Lấy lại vai trò/nhóm mới nhất từ server (gộp vào user hiện có để giữ trường hiển thị SSO như avatar/chức danh).
  // Chỉ đăng xuất khi phiên hết hạn / tài khoản bị khóa (401/403) — lỗi mạng tạm thời thì bỏ qua.
  refreshUser: async () => {
    try {
      const response = await authService.getMe()
      if (response.status === 'success') {
        const user = { ...(get().user || {}), ...response.data }
        authService.setUser(user)
        set({ user })
      }
    } catch (error) {
      if ([401, 403].includes(error.response?.status)) get().logout()
    }
  },

  clearError: () => set({ error: null }),

  // Cập nhật user cục bộ (vd đổi cài đặt nhận thông báo) — đồng bộ luôn localStorage
  setUser: (user) => { authService.setUser(user); set({ user }) },
}))
